import './FarmNotFoundPage.scss';

export function FarmNotFoundPage() {
    return (
        <div className="FarmNotFoundPage">
            <h1>Farm not found</h1>
            <a href="/">Back to Farm switcher</a>
        </div>
    );
}
